import { ContractCommitmentTemplate } from '@core/models/contract-commitment-template.model';

export interface JsonContractCommitment {
  id?: number;
  template?: ContractCommitmentTemplate;
  value?: number;
  contractItemId?: number;
}

export class ContractCommitment {
  id: number;
  template: ContractCommitmentTemplate;
  value: number;
  contractItemId: number;

  constructor(jsonContractCommitment: JsonContractCommitment = null) {
    this.id = jsonContractCommitment.id;
    this.template = jsonContractCommitment.template;
    this.value = jsonContractCommitment.value;
    this.contractItemId = jsonContractCommitment.contractItemId;
  }
}

export interface JsonContractCommitmentImmutable {
  id?: number;
  value?: number;
  contractItemId?: number;
  template?: ContractCommitmentTemplate;
}

export class ContractCommitmentImmutable {
  id: number;
  value: number;
  contractItemId: number;
  template: ContractCommitmentTemplate;

  constructor(jsonContractCommitmentImmutable: JsonContractCommitmentImmutable = null) {
    this.id = jsonContractCommitmentImmutable.id;
    this.value = jsonContractCommitmentImmutable.value;
    this.contractItemId = jsonContractCommitmentImmutable.contractItemId;
    this.template = jsonContractCommitmentImmutable.template;
  }
}

export class CommitmentFormGroup {
  category: string;
  commitments: ContractCommitment[]
}
